import { createContext } from "react";

const TimesheetsContext = createContext();

export default TimesheetsContext;
